import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "narrow-view" }
const _hoisted_2 = { class: "view-full-span" }

import PasswordResetRequestForm from '@/components/forms/PasswordResetRequestForm.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordResetRequestView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('password-reset.heading')), 1),
    _createVNode(PasswordResetRequestForm)
  ]))
}
}

})